import { mutator } from 'satcheljs';
import {
    closeCurrentTimeStreamProject,
    timeStreamProjectPreviewOpened,
} from 'owa-timestream-store';
import { zoomByWheel, zoomIn, zoomOut, resetPanAndZoom } from '../actions';
import getStore from '../store';

function setZoom({ zoom }: { zoom: number }) {
    getStore().zoom = zoom;
}

function resetZoom() {
    getStore().zoom = 1;
}

mutator(zoomIn, setZoom);
mutator(zoomOut, setZoom);
mutator(zoomByWheel, setZoom);
mutator(resetPanAndZoom, setZoom);

mutator(timeStreamProjectPreviewOpened, () => {
    getStore().zoom = 0.5;
});

mutator(closeCurrentTimeStreamProject, resetZoom);
